import { PreferenceChoiceSchema } from '@main/sombra-types';

/**
 * determine the consent value based on  user preferences for a purpose
 *
 * If any one of booleanValue, selectValue, selectValues is set, it will be considered truthy
 *
 * @param preferences - user preferences for a purpose
 * @returns return consent value
 */
export function getConsentFromPreferences(
  preferences: Record<string, PreferenceChoiceSchema>,
): boolean {
  return Object.values(preferences).some((preference) =>
    Boolean(
      preference.booleanValue ||
        preference.selectValue ||
        preference.selectValues?.length,
    ),
  );
}
